import { numericUtil } from '@cmg/common';

import type { ParticipationReportGridColDef } from '../../types';

export const sellingConcessionAmountColDef: ParticipationReportGridColDef = {
  headerName: 'Selling Concessions $',
  field: 'sellingConcessionUsd',
  type: ['numericColumn', 'number'],
  filter: 'agNumberColumnFilter',
  floatingFilter: true,
  valueFormatter: ({ value }) => numericUtil.formatCurrencyInMillions(value, true),
};
